// Generated by run_marine_heat_waves_daily.py. Do not edit by hand.
export const mhwScopeMetadata = {
  "rmi-wake": {
    "monthly": {
      "dates": [
        "2026-06",
        "2026-07",
        "2026-08"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    },
    "seasonal": {
      "dates": [
        "2026-Q2",
        "2026-Q3"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    },
    "decadal": {
      "dates": [
        "2026s"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    }
  },
  "rmi": {
    "monthly": {
      "dates": [
        "2026-06",
        "2026-07",
        "2026-08"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    },
    "seasonal": {
      "dates": [
        "2026-Q2",
        "2026-Q3"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    },
    "decadal": {
      "dates": [
        "2026s"
      ],
      "modes": [
        "gridded",
        "contours",
        "voronoi"
      ]
    }
  }
};
